import { BinIcon } from "../../../../../components/icon/Icon";
import {
    SlideMobileAccountStateFaqAnswersStyled,
    SlideMobileAccountStatStyled
} from "./styled/SlideMobileAccountStateFaqStyled";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext";

function SlideMobileAccountStatFaq(props) {
    const {className} = props;
    const {getLangPath} = useLangContext();

    return <SlideMobileAccountStatStyled className={className}>
        <div className="d-flex">
            <BinIcon name="IcInfoFilled"/>
            <span className="ms-1">{getLangPath('lite_version.home.faq')}</span>
        </div>
        <SlideMobileAccountStateFaqAnswersStyled>
            {
                [
                    'lite_version.home.faq_balance',
                    'lite_version.home.faq_equity',
                    'lite_version.home.faq_pl',
                    'lite_version.home.faq_used_margin',
                    'lite_version.home.faq_free_margin',
                    'lite_version.home.faq_margin_level'
                ].map(key => <div key={key} dangerouslySetInnerHTML={{__html: getLangPath(key)}}/>)
            }
        </SlideMobileAccountStateFaqAnswersStyled>
    </SlideMobileAccountStatStyled>
}

export default SlideMobileAccountStatFaq
